module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_5-ca3753a0ac6a4e8682e755c09ee73304.jpg";